<template>
          
<div> 
        
<div class="header">   
   <div class="branding float-left">
     <h3 class="logo text-center">
         <a href="/#/home">
         <img class="logo-icon" src="static/images/logo.png" alt="icon" />
         <span class="nav-label">
            <span class="highlight">WTIPS</span>v3
          </span>
          </a>
     </h3>
    </div>
			<div class="topbar">
               <headermenu></headermenu>
			</div>	
</div>
		
				
<sidebar></sidebar>
<div id="content-wrapper" class="content-wrapper view projects-view">
																					
	<div class="container-fluid">
		<h2 class="view-title">UOM Master Conversion</h2>
       <div class="actions">
            
       </div>
       <div class="row">

         <uom_master_search :search_uom="uom_text" 
                            :uom_search_view="uom_search_view" 
                            :parent_window="parent_window" 
                            :picked_element="picked_uom_element" 
                            @select_uom_text="update_row_text" 
                            @turn_off_view="false_uom_view">
        </uom_master_search>
         
       </div>
 		<div class="row">	
              
			<div class="wtips_uom_coversion_view col-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12">
			   
				<div class="module-wrapper">
				   
					<section class="module module-has-footer module-projects-overview">
					
						<div class="module-inner">
							<div class="module-heading">
								<h3 class="module-title">Unit of measure conversion list</h3>
								<ul class="actions list-inline">
									<li><a class="collapse-module" data-toggle="collapse" href="#content-overview" aria-expanded="false" aria-controls="content-overview"><span aria-hidden="true" class="icon arrow_carrot-up"></span></a></li>
								</ul>
								<br>
								
								<button class="btn btn-warning" @click="return_parent"><i class="fa fa-mail-reply"></i>Go Back</button>
							</div>
							
							<div class="module-content collapse in" id="content-overview">
								<div class="module-content-inner">

                                
    							<div id="no-more-tables" class="table-responsive">
									<table class="table table-simple table-striped">
										<thead>
											<tr>
												<th style="width: 240px;">UOM From Code</th>
												<th style="width: 240px;">UOM To Code</th>
												<th style="width: 230px;">Conversion value</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item,index) in items">
												<td data-title="UOM From Code." >									
												    <div class="input-group" style="z-index:0">
										              <input type="text" class="form-control" id="from_uom_code" placeholder="Enter 'From' UOM code" v-model="item.from_uom_code" @keyup.enter="search_uom(index,'from_uom_code')">
										              <div class="input-group-addon" @click="search_uom(index,'from_uom_code')"><i class="fa fa-search" ></i></div>
                                                    </div>
									            </td>
												<td data-title="UOM To Code.">
												    <div class="input-group" style="z-index:0">
												      <input type="text" class="form-control" id="to_uom_code" placeholder="Enter 'To' UOM code" v-model="item.to_uom_code" @keyup.enter="search_uom(index,'to_uom_code')">
												      <div class="input-group-addon" @click="search_uom(index,'to_uom_code')"><i class="fa fa-search"></i></div>
												    </div>
												</td>												
                                                 <td data-title="UOM To Code." class="client truncate">
												     
												      <input type="text" class="form-control" id="from_uom_code" placeholder="Enter conversion factor" v-model="item.conversion_factor">
												    
												</td>												
												
												<td data-title="Actions">
                                                     <span>                                                                 
                                                    <button type="button" class="btn twitter-btn"  data-toggle="tooltip" data-placement="bottom" title="Add Row" @click="addRow(index)">
                                                        <i style="color : #fff;" class="fa fa-plus-square"></i> 
                                                      </button>
                                                      <button type="button" class="btn google-btn" data-toggle="tooltip" data-placement="bottom" title="Delete Row" @click="removeRow(index)">
                                                        <i style="color : #fff;"  class="fa fa-trash"></i> 
                                                      </button>
                                                    </span>
                                                </td>
											 </tr>											
										</tbody>
										
									</table>
    				            </div>  
                                
                                 <button type="button" class="data_save btn btn-primary" @click="save_uom_conversion_data">Save</button>                                 
                                 
								</div>
								
							</div>
							
						</div>
                    
				        <div class="module-footer text-center">
                            <p class="meta"><span><li>Modified By:  at : </li></span></p>
						</div>		

						 <spinner :visible="ajax_loader"></spinner>
					</section>
					
				</div>		
            </div>	
            
            		
       </div>	<!--row -->	           
               

   
      
         
    </div>
</div>	

	

			
					
<modalnotify :visible="modalnotify_view" :msg="modal_msg" :modal_title="modal_title"></modalnotify>  	
</div> 
	
</template>

<script>
import headermenu from '@/components/supportcomp/headermenu.vue'      
import sidebar from '@/components/supportcomp/sidebar.vue'
import modalnotify from '@/components/supportcomp/modalnotify.vue' 
import spinner from '@/components/supportcomp/spinner.vue' 
import uom_master_search from '@/components/app-pages/uom-master/uom-master-search.vue' 

export default {
  name: 'uom_master_conversion_view',
  data () {
    return {
      single_view : false,    
      msg: '',
      sideBarVisible : false,
      security_obj : { "access" : {"view" : false ,"edit" : false,"delete" : false}},
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false,
      items : "",
      page_info : "",    
      page : "",
      picked_uom_element : "",
      parent_window : "",
      uom_search_view : false,
      uom_text : ""
    }
  },
  components: {
      headermenu,
      sidebar,
      modalnotify,
      spinner,
      uom_master_search
   },
methods: {
    
      setheightelem : function (){
          
          var x = $('body').height();
          $("#main-nav-wrapper").height(x);  
 	      $('body').toggleClass('compact', $(window).width() <= 1200);
		  $('body').toggleClass('mobile', $(window).width() <= 768);
          
        
      },
    
      refreshTabledetails : function (page){
          
                             var x = this;
                             if (!isNaN(page)){
                             x.page = page;
                             }
                             var object_data = {"data_api_key":'uom_master_view_data', "page" : x.page , "base_module":"uom_master"};
                            
                             x.ajax_loader=true;

      },
    
     setSecurity : function (){
              var x = this;
         var object_data = {"module_name":'uom_master_conversion'};
         x.ajax_loader=true;
         call_Ajax("page_security",object_data).then(function (data){
              x.ajax_loader=false;
             if (!data.result.length){
                    notify_notauthz();                
             }
              $.each( data.result, function( i, val ) {
                  
                  x.security_obj = val;
                  
                    if (!val.access.view)
                        {
                                notify_notauthz();
                        }
                    else
                        {
                            
                             
                            var object_data = {"data_api_key":'uom_master_conversion_view_data', "base_module":"uom_master_conversion"};
                             x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                 
                                     x.ajax_loader=false;
                                 
                                   if (data.data == "No_records")
                                       
                                       {
                                           
                                           x.items = [{"from_uom_code" : "", "to_uom_code" : "", "conversion_factor" : "" }];
                                           
                                       }
                                 
                                   else
                                       {
                                           
                                           $.each( data.data, function( i, val ) {
                                                   
                                                    
                                                  x.items = val.items;
                                               
                                                });                                            
                                           
                                           
                                       }
                                 
                                      //MstObj.items = data.data;

                                    

                                 
                             })
                              .fail(function(){
                                 x.ajax_loader=false; 
                             });                               
                        }
              });
         })
         .fail(function(){
             x.ajax_loader=false; 
         });
           
      },//


    return_parent : function () {
             var x = this;
             $(".wtips_uom_table_view").hide(600);
             setTimeout(function(){ $(location).attr('href','/#/general-settings'); }, 900);
    }, //

       addRow: function (index) {
            
            try {
                 
                
                  if ( this.items.length == index+1 ) {
                       
                    
                      
                     if (this.items[index].from_uom_code == "") {
                            notify_ok('<b>From UOM</b> cannot be empty','center');
                         return;
                     }                      
                      if (this.items[index].to_uom_code == "") {
                            notify_ok('To UOM cannot be empty','center');
                         return;
                     }   
                      
                     this.items.splice(index + 1, 0, {"from_uom_code" : "", "to_uom_code" : "", "conversion_factor" : "" });
                }
            } catch(e)
            {
                console.log(e);
            }
        },
    removeRow: function (index) {
           if (index>0){
            this.items.splice(index, 1);
           }
        },
    
    save_uom_conversion_data : function (){
        
        
                              var x = this;
        
                              var object_data = {"data_api_key":'save_uom_coversion_data', "uom_data" : x.items , "base_module":"uom_master_conversion"};
                            
                             x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                     
                                      x.ajax_loader=false;
                                 
            
                                    if (data.data=="ERR"){

                                                      notify('Error occured on saving data', 'warn',true,false,'topLeft');                                    
                                        
                                    }
                                  
                                    if (data.data=="SUCCESS")
                                        {
                                            
                                                      notify('UOM conversion data saved successfully', 'info',true,false,'topLeft')
                                            
                                        }
                                 
                             })
                              .fail(function(){
                                 x.ajax_loader=false; 
                             }); //          
        
        
        
        
        //
    },
    

    search_uom : function (index, key){
           
        var x = this;
          
        x.picked_uom_element = {index : index , key : key}
        
             if (x.picked_uom_element.key == "from_uom_code"){
                   
                 x.uom_text = x.items[x.picked_uom_element.index].from_uom_code;
                 
             }             
             if (x.picked_uom_element.key == "to_uom_code"){
                 
                   
                 x.uom_text = x.items[x.picked_uom_element.index].to_uom_code;
                 
             }        
        
        x.parent_window = $(".wtips_uom_coversion_view");
        x.uom_search_view = true;
        $(".wtips_uom_coversion_view").hide(600);
        $(".wtips_uom_table_search").show(600);
        
        
    
    },
    
    false_uom_view : function (){
        var x = this;
        x.uom_search_view = false;
        
    },
    
    update_row_text : function (uom_code){
           var x = this;

             if (x.picked_uom_element.key == "from_uom_code"){
                   
                 x.items[x.picked_uom_element.index].from_uom_code = uom_code;
                 
             }             
             if (x.picked_uom_element.key == "to_uom_code"){
                 
                   
                 x.items[x.picked_uom_element.index].to_uom_code = uom_code;
                 
             }
    }    
    
}, //end of Methods //
    
    
mounted : function () {
       var x = this;
       setTimeout(function(){ x.setheightelem(); x.setSecurity(); }, 200);
    
       this.uom_search_view = false;
       $(".wtips_uom_table_search").hide(0);
   } //end of mounted
}

</script>



// WEBPACK FOOTER //
// src/components/app-pages/uom-master-conversion/uom-master-conversion-view.vue